import React, { FC } from 'react';
import { useViewModel } from '@utils';
import { observer } from 'mobx-react-lite';
import { Button } from '../button';
import { Modal } from '../modal';
import '../../styles/components/confirmDialog.scss';
import { MessageDialogViewModel } from './MessageDialogService';

export const MessageDialog: FC = observer(() => {
  const messageDialogViewModel = useViewModel(MessageDialogViewModel);

  return (
    <Modal
      width={418}
      maxWidth={418}
      isShow={messageDialogViewModel.isShow}
      closeModal={messageDialogViewModel.onCancel}
      renderButtons={() => (
        <>
          <Button
            title="Да"
            onClick={messageDialogViewModel.onAccept}
          />
          <Button
            title="Нет"
            className="outlined cancel-button"
            onClick={messageDialogViewModel.params.isPlaner ? messageDialogViewModel.onReject : messageDialogViewModel.onCancel}
          />
          {messageDialogViewModel.params.isPlaner && (
            <Button
              title="Отмена"
              className="outlined"
              onClick={messageDialogViewModel.onCancel}
            />
          )}
        </>
      )}
    >
      <div className="confirmMessage">
        {messageDialogViewModel.params.message}
      </div>

    </Modal>
  );
});
